"use strict";
/*
 * Created on 19. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Result of action on a release.
 *
 * @author Radek Beran
 */


var ReleaseActionResult =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ReleaseActionResult, _DomainObject_1$Domai);

  function ReleaseActionResult(successAll, releaseId, action, results) {
    var _this;

    _classCallCheck(this, ReleaseActionResult);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseActionResult).call(this));
    _this.successAll = successAll;
    _this.releaseId = releaseId;
    _this.action = action;
    _this.results = results;
    return _this;
  }

  return ReleaseActionResult;
}(DomainObject_1.DomainObject);

exports.ReleaseActionResult = ReleaseActionResult;